// extracted by mini-css-extract-plugin
export default {"conteneur_form_mdp_oublier":"form-mot-de-passe-oublier_conteneur_form_mdp_oublier__+PZLJ"};